module.exports = __webpack_public_path__ + "static/media/Oct3-F19.68c273b1.png";